<template>
  <q-page class="column items-center">
    <portal to="header">
      <BaseHeaderFrame>
        <!--  -->
      </BaseHeaderFrame>
    </portal>

    <div class="col full-width content-end relative-position"
      :class="backgroundImage">
      <div class="absolute-full">
        <div class="column items-center full-height">
          <div class="col content-center">
            <template v-if="extraFlow && extraFlow.type == 'cinemaDeal'">
              <img
                src="~assets/wit-tekst-logo.svg"
                style="
                  width: 70vw;
                  max-width: 280px;
                  margin-top: 100px;
                  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, .5));"
              />
            </template>
          </div>
          <div class="col-auto">
            <div class="row items-end text-center q-pa-sm">
              <div class="col-12 q-pb-sm_">
                <div class="text-body-regular text-weight-medium-2 q-mb-sm" v-if="userFullname">
                  <span class="text-weight-bold">{{ userFullname }}</span>&nbsp;<!--
                  --><span class="text-weight-medium-2">(</span>
                  <a href="javascript:void(0);" @click="logoutTrigger" class="text-weight-medium text-secondary">{{ $t('common.logout').toLowerCase() }}</a>
                  <span class="text-weight-medium-2">)</span>
                </div>
                <template v-if="!extraFlow">
                  <div class="text-body-regular text-weight-medium-2" v-html="$t('pages.index.heading1')"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto self-center self-stretch">
      <div class="row items-center text-center q-px-sm q-pb-sm q-mx-auto width-custom">
        <div class="col-12 q-pb-lg">
          <template v-if="!extraFlow">
            <div v-if="!extraFlow" class="text-body-regular text-weight-medium-2" v-html="$t('pages.index.heading3')"></div>
          </template>
        </div>

        <div class="col-12">
          <div class="row q-col-gutter-md q-px-sm q-pb-lg">
            <template v-if="extraFlow">
              <div class="col-12">
                <q-btn
                  :label="$t('pages.index.start')"
                  color="primary"
                  size="16px"
                  unelevated
                  no-caps
                  class="full-width q-btn--generic"
                  @click="openFormTrigger" />
              </div>
            </template>
            <template v-else>
              <div class="col-12">
                <q-btn
                  :label="$t('pages.index.today')"
                  color="primary"
                  size="16px"
                  unelevated
                  no-caps
                  class="full-width q-btn--generic"
                  @click="openFormTrigger('today')" />
              </div>
              <div class="col-12">
                <q-btn
                  :label="$t('pages.index.tomorrowOrLater')"
                  color="primary"
                  size="16px"
                  outline
                  no-caps
                  class="full-width q-btn--generic"
                  @click="openFormTrigger('tomorrowOrLater')" />
              </div>
            </template>
          </div>
        </div>

        <div class="col-12 q-px-md q-pb-lg" v-if="!changeReservationDisabled">
          <router-link
            :to="{ name: token ? 'reservations-list' : 'reservations-retrieve' }"
            class="text-secondary text-weight-medium-2"
          >
            {{ $t("pages.index.changeReservation") }}</router-link>
          <br>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { date as dateUtils } from 'quasar'
import { mapActions, mapGetters } from 'vuex'
import _kebabCase from 'lodash/kebabCase'

const XMAS_LANDING_URL = 'https://www.loetje.nl/nl/feestdagen-2025/'

export default {
  name: 'IndexPage',
  data () {
    return {
      xmasLandingUrl: XMAS_LANDING_URL
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'extraFlow'
    ]),
    ...mapGetters('auth', [
      'userFullname'
    ]),
    backgroundImage () {
      let bgClass = 'b-col--index-bg'
      if (this.extraFlow) {
        bgClass = 'b-col--' + _kebabCase(this.extraFlow.type) + '-bg'
        switch (this.extraFlow.type) {
          case 'voucher':
            bgClass = 'b-col--ah-actie-bg'
            break
          case 'cinemaDeal':
            bgClass = 'b-col--ah-actie-bg'
            break
          case 'loversBurger':
            bgClass = 'b-col--index-bg'
            break
        }
      }
      return bgClass
    },
    // ASANA: disable the line/option 'Modify or cancel existing reservation' in the widget until December 26.
    changeReservationDisabled () {
      return dateUtils.formatDate(new Date(), 'YYYY-MM-DD') <= '2025-12-26'
    }
  },
  methods: {
    ...mapActions('reservationForm', [
      'setFormData',
      'setFormItem'
    ]),
    ...mapActions('auth', [
      'logout'
    ]),
    openFormTrigger (type) {
      let date

      switch (type) {
        case 'today':
          date = dateUtils.addToDate(new Date(), { hours: 1 })
          date = dateUtils.formatDate(date, 'YYYY-MM-DD')
          break
        case 'tomorrowOrLater':
          date = dateUtils.addToDate(new Date(), { days: 1 })
          date = dateUtils.formatDate(date, 'YYYY-MM-DD')
          break
        default:
          date = dateUtils.addToDate(new Date(), { hours: 1 })
          date = dateUtils.formatDate(date, 'YYYY-MM-DD')
          break
      }

      this.setFormItem({ key: 'date', value: date })
      this.$router.push({ name: 'filter' }).catch(() => {})
    },
    async logoutTrigger () {
      this.$q.loading.show()
      await this.logout()
      this.$q.loading.hide()
      // this.$router.push({ name: 'index' })
    },
    openXmasFormTrigger () {
      this.setFormItem({ key: 'date', value: '2024-12-25' })
      this.$router.push({ name: 'filter' }).catch(() => {})
    }
  }
}
</script>
